export enum PeriodRangeType {
    day = 0,
    weekToDate = 1,
    monthToDate = 2,
    quarterToDate = 3,
    sixMonthsToDate = 4,
    yearToDate = 5,
    custom = 7
}

export interface IDateRangeSelection {
    dateLabel: string;
    startDate: Date;
    endDate: Date;
    periodType: PeriodRangeType;
}

export const DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMMM Y',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM Y',
    },
};
